import Box from "@mui/material/Box";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  type ToolbarPropsOverrides,
} from "@mui/x-data-grid-pro";
import { GridExportMenu } from "@/components/export/GridExportMenu";

/**
 * The grid toolbar for pages without saved table settings: columns, filter, density, export and
 * quick filter. Configure it through the grid's `slotProps.toolbar` (`report`, `fractionDigits`,
 * `exportDisabled`, `exportAllColumns`, `exportForcedFields`, `hideFilter`, `hideDensity`, `hideQuickFilter`), so a page
 * needs no wrapper component. Pages with saved settings and views use `CustomToolbar` instead.
 */
export function ExportToolbar({
  report,
  fractionDigits,
  exportDisabled,
  exportAllColumns,
  exportForcedFields,
  hideFilter,
  hideDensity,
  hideQuickFilter,
}: ToolbarPropsOverrides) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      {!hideFilter && <GridToolbarFilterButton />}
      {!hideDensity && <GridToolbarDensitySelector />}
      <GridExportMenu
        report={report ?? { title: document.title || "export" }}
        fractionDigits={fractionDigits}
        disabled={exportDisabled}
        allColumns={exportAllColumns}
        forcedFields={exportForcedFields}
      />
      {!hideQuickFilter && (
        <>
          <Box sx={{ flex: 1 }} />
          <GridToolbarQuickFilter debounceMs={300} />
        </>
      )}
    </GridToolbarContainer>
  );
}
